export const DOMAINS = {
  dev: 'dev',
  explore: 'explore',
  enterpriseExplore: 'enterpriseExplore',
} as const;
